export default __webpack_public_path__ + "static/team-image-6-13b64f748f5702cd36784a5b0258c771.png";